import React from "react";
import { SidebarWrapper } from "./dashboardSidebarStyling";
import { connect } from "react-redux";
import { withRouter, Link } from 'react-router-dom';
import { fetchMenu } from "../../../actions/menuActions";
import CacheStorage from '../../../utils/CacheStorage';


const menuIcons = {
  "Dashboard": require("../../../common/images/IC_home.svg"),
  "Data Management": require("../../../common/images/IC_data_management.svg"),
  "Capability Modeling": require("../../../common/images/IC_cap_modeling.svg"),
  "AmpMarking": require("../../../common/images/IC_ampmarking.svg"),
  "Performance Measuring": require("../../../common/images/IC_perfom_measuring.svg"),
  "Org Structure": require("../../../common/images/IC_org.svg"),
  "Design Led Materiality": require("../../../common/images/IC_design_led.svg"),
  "Manage Team": require("../../../common/images/IC_amplofly_team.svg"),
  "Pain Point Initiative": require("../../../common/images/IC_carbon_emission.svg"),
  "Agentic AI": require("../../../common/images/IC_agentic_ai.svg"),
};

// ✅ icons for submenu items
const subMenuIcons = {
  "Tutorial": require("../../../common/images/IC_tutorial.svg"),
  "Assessment": require("../../../common/images/IC_assessment.svg"),
  "Peer": require("../../../common/images/IC_peer.svg"),

  "Modeling Workbench": require("../../../common/images/IC_modeling_workbench.svg"),
  "Capability Mapping": require("../../../common/images/IC_capability_mapping.svg"),

  "Perf. Measuring Details": require("../../../common/images/IC_Perf_Measuring.svg"),

  "Design Led Materiality Projects": require("../../../common/images/IC_design_led_materiality_projects.svg"),
  "Network of Influence": require("../../../common/images/IC_network_of_influence.svg"),

  "Data Upload": require("../../../common/images/IC_data_upload.svg"),
  "Data Templates": require("../../../common/images/IC_data_template.svg"),
  "Carbon Emission": require("../../../common/images/IC_carbon_emission.svg"),
};


// label aliasing
const labelFor = (name) => (name === "Performance Measuring" ? "Performance" : name);
const projectId = localStorage.getItem("DecompositionProjectID");


class DashboardSidebar extends React.Component {
  render() {
    const homeLabel = CacheStorage.getItem("menutext") === "dashboard" ? "Home" : "Manage";

    return (
      <SidebarWrapper>
        <ul className="navbar-nav bg-gradient-primary sidebar sidebar-dark accordion" id="accordionSidebar">
          <div className="sidebar-container-bg">
            {/* Home */}
            <li className="nav-item active">
              <Link className="nav-link" to="/dashboard" title={homeLabel}>
                <img
                  src={require("../../../common/images/IC_home.svg")}
                  className="sidebar-icon"
                  alt="Org Icon"
                  style={{ marginTop: '-3px' }}
                />
                <span style={{ marginLeft: '10px' }}>{homeLabel}</span>{" "}
                <span className="badge badge-info badge-counter beta-b">Beta</span>
              </Link>
            </li>

            {/* Section Heading */}
            <div className="sidebar-heading">
              {CacheStorage.getItem('menutext') === 'dashboard' ? 'ORGANIZATION' : 'CONFIGURATION'}
            </div>

            {/* Org Structure / Team Management */}
            {CacheStorage.getItem('menutext') === 'dashboard' && CacheStorage.getItem('userType') === "2" ? (
              <>
                <li className="nav-item">
                  <Link className="nav-link" to="/getting-started" title="Getting Started">
                    <i>
                      <img
                        src={subMenuIcons["Getting Started"]}
                        className="sidebar-icon"
                        alt="Getting Started"
                      />
                    </i>
                    <span>Getting Started</span>
                  </Link>
                </li>
                <li className="nav-item">
                  <Link className="nav-link" to="/agentic-ai" title="Agentic AI">
                    <i>
                      <img
                        src={menuIcons["Agentic AI"]}
                        className="sidebar-icon"
                        alt="Agentic AI"
                        style={{ marginTop: '-3px' }}
                      />
                    </i>
                    <span style={{ marginLeft: '5px' }}>Agentic AI</span>
                  </Link>
                </li>
              </>
            ) : (
              <>
                <li className="nav-item">
                  <Link className="nav-link" to="/new-company-profile" title="Org Structure">
                    <i>
                      <img src={menuIcons["Org Structure"]} className="sidebar-icon" alt="Org Structure" />
                    </i>
                    <span>Org Structure</span>
                  </Link>
                </li>
                <li className="nav-item">
                  <Link className="nav-link" to="/manage-team" title="User Management">
                    <img
                      src={require('../../../common/images/IC_amplofly_team.svg').default || require('../../../common/images/IC_amplofly_team.svg')}
                      alt=""
                      aria-hidden="true"
                      className="sidebar-icon"
                      loading="lazy"
                      style={{ marginTop: '-6px' }}
                    />
                    <span style={{ marginLeft: '5px' }}>User Management</span>
                  </Link>
                </li>
                {((CacheStorage.getItem("userEmail") || "").toLowerCase() === "superadmin@amplo.com" || (localStorage.getItem("userEmail") || "").toLowerCase() === "superadmin@amplo.com") && (
                  <li className="nav-item">
                    <Link className="nav-link" to="/admin/module-requests" title="Module Requests">
                      <img
                        src={require('../../../common/images/IC_amplofly_team.svg').default || require('../../../common/images/IC_amplofly_team.svg')}
                        alt=""
                        aria-hidden="true"
                        className="sidebar-icon"
                        loading="lazy"
                        style={{ marginTop: '-6px' }}
                      />
                      <span style={{ marginLeft: '5px' }}>Module Requests</span>
                    </Link>
                  </li>
                )}
                <li className="nav-item">
                  <Link className="nav-link" to="/agentic-ai" title="Agentic AI">
                    <i>
                      <img
                        src={menuIcons["Agentic AI"]}
                        className="sidebar-icon"
                        alt="Agentic AI"
                        style={{ marginTop: '-3px' }}
                      />
                    </i>
                    <span style={{ marginLeft: '5px' }}>Agentic AI</span>
                  </Link>
                </li>
              </>
            )}

            {/* Section Heading */}
            <div className="sidebar-heading">
              MODULES
            </div>

            {/* Dynamic Menus */}
            {(() => {
              if (!this.props.menuItems) return null;
              const activeMappingStr = CacheStorage.getItem("active_module_mapping");
              let filtered = this.props.menuItems;
              if (activeMappingStr) {
                try {
                  const mapping = JSON.parse(activeMappingStr);
                  if (Array.isArray(mapping) && mapping.length > 0) {
                    if (mapping.includes("All")) {
                      filtered = this.props.menuItems;
                    } else {
                      filtered = this.props.menuItems.filter(menu =>
                        mapping.some(m => menu.menuName.toLowerCase().includes(m.toLowerCase()) || m.toLowerCase().includes(menu.menuName.toLowerCase()))
                      );
                    }
                  }
                } catch (e) {}
              }
              return filtered.map(menu => {
                const iconSrc = menuIcons[menu.menuName]
                  ? menuIcons[menu.menuName]
                  : require("../../../common/images/IC_ampmarking.svg");
                const label = labelFor(menu.menuName);
                const tooltip = menu.menuName;

                return (
                  <li key={menu.menuId} className="nav-item">
                    <a
                      className="nav-link collapsed"
                      href="#"
                      data-toggle="collapse"
                      data-target={menu.subMenu.length ? "#collapse" + menu.menuId : ""}
                      aria-expanded="true"
                      title={tooltip}
                    >
                      <img
                        style={{ marginTop: '1px' }}
                        src={iconSrc}
                        className="sidebar-icon"
                        alt={menu.menuName + " icon"}
                      />
                      <span className="menu-text" style={{ marginLeft: '5px' }}>{label}</span>
                    </a>

                    {menu.subMenu.length > 0 && (
                      <div
                        id={"collapse" + menu.menuId}
                        className="collapse"
                        aria-labelledby="headingTwo"
                        data-parent="#accordionSidebar"
                      >
                        <div className="collapse-inner rounded">
                          {menu.subMenu.map(sub => {
                            const subIconSrc = subMenuIcons[sub.menuName]
                              ? subMenuIcons[sub.menuName]
                              : require("../../../common/images/IC_home.svg");

                            const displayName =
                              sub.menuName === "Perf. Measuring Details" ? "KPI List" : sub.menuName;

                            return (
                              <Link
                                key={sub.menuId}
                                className="collapse-item"
                                to={{ pathname: sub.link, state: "flushDeal" }}
                                title={displayName}
                              >
                                <img
                                  src={subIconSrc}
                                  alt={displayName + " icon"}
                                  className="submenu-icon"
                                  style={{ width: "16px", height: "16px", marginRight: "6px" }}
                                />
                                {displayName}
                              </Link>
                            );
                          })}
                        </div>
                      </div>
                    )}
                  </li>
                );
              });
            })()}

            {/* Static Data Management */}
            {(!CacheStorage.getItem("active_module_mapping") || 
              CacheStorage.getItem("active_module_mapping").includes("Data Management") ||
              CacheStorage.getItem("active_module_mapping").includes("All")) && (
              <li className="nav-item">
              <a
                className="nav-link collapsed"
                href="#"
                data-toggle="collapse"
                data-target="#collapseDataManagement"
                aria-expanded="false"
                title="Data Management"
              >
                <img
                  src={menuIcons["Data Management"]}
                  alt="Data Management"
                  className="sidebar-icon"
                />
                <span style={{ marginLeft: '5px' }}>Data Management</span>
              </a>
              <div
                id="collapseDataManagement"
                className="collapse"
                aria-labelledby="headingDataManagement"
                data-parent="#accordionSidebar"
              >
                <div className="collapse-inner rounded">
                  <Link className="collapse-item" to={`/data-management/report`} title="Data Upload">
                    <img
                      src={subMenuIcons["Data Upload"]}
                      alt="Data Upload icon"
                      className="submenu-icon"
                      style={{ width: "16px", height: "16px", marginRight: "6px" }}
                    />
                    Data Upload
                  </Link>
                  <Link className="collapse-item" to="/data-management/category-dashboard" title="Data Templates">
                    <img
                      src={subMenuIcons["Data Templates"]}
                      alt="Data Templates icon"
                      className="submenu-icon"
                      style={{ width: "16px", height: "16px", marginRight: "6px" }}
                    />
                    Data Templates
                  </Link>
                  <Link className="collapse-item" to="/data-management/carbon-emission" title="Carbon Emission">
                    <img
                      src={subMenuIcons["Carbon Emission"]}
                      alt="Carbon Emission icon"
                      className="submenu-icon"
                      style={{ width: "16px", height: "16px", marginRight: "6px" }}
                    />
                    Carbon Emission
                  </Link>
                </div>
              </div>
            </li>
            )}
            {/* Pain Point Initiative */}
            {(!CacheStorage.getItem("active_module_mapping") || 
              CacheStorage.getItem("active_module_mapping").includes("Capability Modeling") ||
              CacheStorage.getItem("active_module_mapping").includes("All")) && (
              <li className="nav-item">
              <Link
                className="nav-link"
                to="#"
                onClick={(e) => {
                  e.preventDefault();
                  const projectId = sessionStorage.getItem("DecompositionProjectID");
                  const validId =
                    projectId && projectId !== "undefined" && projectId !== "null"
                      ? projectId
                      : 0;

                  if (!validId || validId === "0") {
                    alert("No project selected yet!");
                    return;
                  }

                  this.props.history.push(`/painpoint-initiatives/${validId}/undefined/0`);
                }}
                title="Pain Point Initiative"
              >
                <img
                  src={menuIcons["Pain Point Initiative"]}
                  alt="Pain Point Initiative icon"
                  className="sidebar-icon"
                  style={{ marginTop: "-2px" }}
                />
                <span style={{ marginLeft: "5px" }}>Pain Point Initiative</span>
              </Link>
            </li>
            )}
            {/* Reporting */}
            {(!CacheStorage.getItem("active_module_mapping") || 
              CacheStorage.getItem("active_module_mapping").includes("Reporting") ||
              CacheStorage.getItem("active_module_mapping").includes("Reports & Analytics") ||
              CacheStorage.getItem("active_module_mapping").includes("All")) && (
              <li className="nav-item">
              <a
                className="nav-link collapsed"
                href="#"
                data-toggle="collapse"
                data-target="#collapseReporting"
                aria-expanded="false"
                title="Reporting"
              >
                <img
                  src={menuIcons["AmpMarking"]} // You can change icon if you have a specific one
                  alt="Reporting"
                  className="sidebar-icon"
                />
                <span style={{ marginLeft: '5px' }}>Reporting</span>
              </a>
              <div
                id="collapseReporting"
                className="collapse"
                aria-labelledby="headingReporting"
                data-parent="#accordionSidebar"
              >
                <div className="collapse-inner rounded">
                  <Link className="collapse-item" to="/reporting/dashboard" title="Dashboard">
                    <img
                      src={subMenuIcons["Tutorial"]} // replace if you have a dedicated icon
                      alt="Dashboard icon"
                      className="submenu-icon"
                      style={{ width: "16px", height: "16px", marginRight: "6px" }}
                    />
                    Dashboard
                  </Link>
                  <Link className="collapse-item" to="/reporting/brsr-configuration" title="Configuration">
                    <img
                      src={subMenuIcons["Tutorial"]}
                      alt="Config icon"
                      className="submenu-icon"
                      style={{ width: "16px", height: "16px", marginRight: "6px" }}
                    />
                    Configuration
                  </Link>
                  <Link className="collapse-item" to="/reporting/brsr-structure" title="BRSR Structure">
                    <img
                      src={subMenuIcons["Tutorial"]}
                      alt="BRSR Structure icon"
                      className="submenu-icon"
                      style={{ width: "16px", height: "16px", marginRight: "6px" }}
                    />
                    BRSR structure
                  </Link>
                </div>
              </div>
            </li>
            )}
          </div>
        </ul>
      </SidebarWrapper>
    );
  }
}

const mapStateToProps = state => ({
  menuItems: state.menu.items
});

export default withRouter(
  connect(mapStateToProps, { fetchMenu })(DashboardSidebar)
);
